import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";

import Grid from "@material-ui/core/Grid";

import { Button, Paper } from "@material-ui/core";
import Spacer from "../../components/Spacer";
import MainContainer from "../../components/MainContainer";
import { headerDataAdmin } from "../../data/modules/admin-header";
import { useNavigate } from "react-router-dom";
import SearchIcon from '@mui/icons-material/Search';
import DirectionService from "../../services/DirectionService";
import CircularProgress from '@mui/material/CircularProgress';
import { saveAs } from 'file-saver';
import {
  FormControl,
  Select,
  MenuItem,
  InputLabel
} from "@material-ui/core";
import PlanningService from "../../services/PlanningService";
import UserService from "../../services/UserService";
import ExcelJS from 'exceljs';
import StagiaireTable from "./StagiaireTable";


const useStyles = makeStyles((theme) => ({
  paper: {
    padding: theme.spacing(2),
    display: "flex",
    overflow: "auto",
    flexDirection: "column",
    elevation: 0,
  },
}));

export default function StagiaireList() {
  const navigate = useNavigate();

  const classes = useStyles();
  const [direction, setDirection] = useState([]);
  const [service, setService] = useState([]);
  const [form, setForm] = useState({
    direction_id: localStorage.getItem("USER_DIR"),
    service_id: 0,
    type: "all"
  });
  const [filters, setFilters] = useState({
    direction_id: localStorage.getItem("USER_DIR"),
    service_id: 0,
    type: "all"
  });
  const iddiruser = localStorage.getItem("USER_DIR");
  const [iddir, setIddir] = useState(0);
  const [loading, setLoading] = useState(false);

  function handleClick() {
    navigate("/stglist/add");
  }

  const handleexportexcel = async () => {
    setLoading(true);

    try {
      // Récupérer les données
      const result = await UserService.getListstg(filters.direction_id, filters.service_id, filters.type);
      if (!result?.data) return;

      const users = result.data;

      // Créer un nouveau workbook
      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet('Liste du personnel');

      // Définir les colonnes avec leurs en-têtes
      worksheet.columns = [
        { header: 'Matricule', key: 'registration_number', width: 15 },
        { header: 'Direction', key: 'direction', width: 20 },
        { header: 'Service', key: 'service', width: 20 },
        { header: 'Fonction', key: 'function_name', width: 20 },
        { header: 'Nom', key: 'last_name', width: 20 },
        { header: 'Prénom', key: 'first_name', width: 20 },
        { header: 'Sexe', key: 'sex', width: 20 },
        { header: 'Email', key: 'email', width: 25 },
        { header: 'Téléphone', key: 'telephone', width: 15 },
        { header: 'Financement', key: 'funding', width: 15 }
      ];

      // Appliquer le style aux en-têtes
      const headerRow = worksheet.getRow(1);
      headerRow.eachCell((cell) => {
        cell.fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: 'D9E1F2' }
        };
        cell.font = {
          bold: true,
          color: { argb: '000000' }
        };
        cell.alignment = { horizontal: 'center' };
      });

      // Ajouter les données
      users.forEach(user => {
        worksheet.addRow({
          registration_number: user.registration_number,
          direction: user.direction,
          service: user.service,
          function_name: user.function_name,
          last_name: user.last_name,
          first_name: user.first_name,
          email: user.email,
          telephone: user.telephone,
          funding: user.funding,
          sex: user.sex_id === "1" ? "Homme" : "Femme"
        });
      });

      // Générer le fichier Excel
      const buffer = await workbook.xlsx.writeBuffer();

      // Télécharger le fichier
      const blob = new Blob([buffer], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      });
      saveAs(blob, 'list_personnel.xlsx');

    } catch (error) {
      console.error("Erreur lors de l'export :", error);
    } finally {
      setLoading(false);
    }
  };

  function handleChangeDirection(event) {
    const { name, value } = event.target;
    setForm({ ...form, [name]: value });
    setIddir(value);
  }

  function handleChangeService(ev) {
    const { name, value } = ev.target;
    setForm({ ...form, [name]: value });
  }

  function handleChangeType(ev) {
    const { name, value } = ev.target;
    setForm({ ...form, [name]: value });
  }

  useEffect(() => {
    setIddir(localStorage.getItem("USER_DIR"));
    DirectionService.getDirection().then((res) => {
      if (res && res.status) {
        setDirection(res.data);
      }
    });
  }, []);

  useEffect(() => {
    if (iddir !== 0 && iddir !== "") {
      PlanningService.Direction(iddir).then((results) => {
        if (results && results.data) {
          setService(results.data);
        }
      })
    }
  }, [iddir]);

  const handleSubmit = () => {
    setFilters({
      direction_id: form.direction_id,
      service_id: form.service_id,
      type: form.type
    });
  };

  return (
    <MainContainer {...headerDataAdmin}>
      <Grid container item xs={12}>
        <Spacer x={2} />
        <Button
          variant="contained"
          color="primary"
          onClick={handleSubmit}
          startIcon={<SearchIcon />}
          style={{ fontWeight: 800, width: 170 }}
        >
          Filtrer
        </Button>
        <Spacer x={2} />
        <Button
          variant="contained"
          onClick={handleexportexcel}
          style={{ fontWeight: 800, width: 170 }}
          disabled={loading}
        >
          {loading ? (
            <>
              <CircularProgress size={24} color="inherit" /> Chargement....
            </>
          ) : (
            "Exporter"
          )}
        </Button>
        <Spacer x={2} />
        <Button
          variant="contained"
          color="secondary"
          onClick={handleClick}
          style={{ fontWeight: 600 }}
        >
          CREER
        </Button>
      </Grid>
      <Spacer y={8} />
      <Grid container spacing={3} justifyContent="center">
        <Grid item xs={12} md={5} sm={4} lg={4}>
          <FormControl fullWidth variant="outlined" size="small">
            <InputLabel id="demo-simple-select-outlined-label">Direction</InputLabel>
            <Select
              labelId="demo-simple-select-outlined-label"
              id="demo-simple-select-outlined"
              label="Direction"
              value={form.direction_id}
              name="direction_id"
              onChange={handleChangeDirection}
              disabled={parseInt(iddiruser, 10) !== 1}
            >
              <MenuItem value={0}>Toutes</MenuItem>
              {direction.map((row) => (
                <MenuItem key={row.direction_id} value={row.direction_id}>
                  {row.code}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={12} md={5} sm={4} lg={4}>
          <FormControl fullWidth variant="outlined" size="small">
            <InputLabel id="demo-simple-select-outlined-label-service">Service</InputLabel>
            <Select 
              labelId="demo-simple-select-outlined-label-service" 
              id="demo-simple-select-outlined-service" 
              label="Service" 
              value={form.service_id} 
              name="service_id" 
              onChange={handleChangeService}
            >
              <MenuItem value={0}> Tous </MenuItem>
              {service.map((row) => (
                <MenuItem key={row.service_id} value={row.service_id}>{row.code}</MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={12} md={5} sm={4} lg={4}>
          <FormControl fullWidth variant="outlined" size="small" required>
            <InputLabel>Période</InputLabel>
            <Select
              label="Période"
              name="type"
              value={form.type}
              onChange={handleChangeType}
            >
              <MenuItem value="all">Tous</MenuItem>
              <MenuItem value="1">En cours</MenuItem>
              <MenuItem value="0">Fin</MenuItem>
            </Select>
          </FormControl>
        </Grid>
      </Grid>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Paper className={classes.paper} variant="outlined">
            <StagiaireTable dir={filters.direction_id} idservice={filters.service_id} type={filters.type} />
          </Paper>
        </Grid>
      </Grid>
    </MainContainer>
  );
}